import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { IntegrationLogReport } from './Pages';

export const IntegrationLogReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={IntegrationLogReport} />

    </Fragment>
)